import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../productPageStyle.js";
import recordId from "../recordId.js";

const useStyles = makeStyles(styles);

/**
 * B-01 §28.3 items 1 and 2: the certification statement and its expiry.
 *
 * This is the page's single strong colour moment, and it is typographic —
 * §26.2 forbids leaf, globe and green-tick imagery, so there is no badge to
 * draw. The record reads as a seal because of scale and ground, not iconography.
 */
export default function SealSection({ t, product }) {
  const classes = useStyles();

  // certValidUntil is a date-only ISO string ("2027-04-01"). Parsed bare,
  // Date treats it as UTC midnight, so a viewer west of UTC sees the previous
  // day. Appending a local time component makes the parse (and the rendered
  // day) local, matching the ISO string's day everywhere.
  const formatted = product.certValidUntil
    ? new Date(product.certValidUntil + "T00:00:00").toLocaleDateString(
        t.dateLocale
      )
    : "";

  // hu-HU formats a date as "2027. 06. 22." — trailing period and all. The
  // Hungarian suffix attaches to the day itself, so leaving the period in
  // produces "2027. 06. 22.-ig". Locales whose variant needs no suffix keep
  // their own punctuation untouched.
  const validUntil =
    t.sealValidSuffix && formatted
      ? formatted.replace(/\.\s*$/, "") + t.sealValidSuffix
      : formatted;

  return (
    <section id="section-seal" className={classes.seal}>
      <div className={classes.band}>
        <div className={classes.inner}>
          <div className={classes.sealInner}>
            <div className={classes.sealStatement}>
              <span className={classes.sealLabel}>{t.sealStatusLabel}</span>
              <h2 className={classes.sealHeading}>{t.certHeading}</h2>
            </div>

            <div className={classes.sealFacts}>
              <div className={classes.sealFactRow}>
                <span className={classes.sealFactLabel}>
                  {t.sealValidLabel}
                </span>
                <p className={classes.sealFactValue}>{validUntil}</p>
              </div>
              <div
                className={`${classes.sealFactRow} ${classes.sealFactRowId}`}
              >
                <span className={classes.sealFactLabel}>{t.heroAuthId}</span>
                <p className={classes.sealFactValueSmall}>{recordId(product)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
